export default __webpack_public_path__ + "static/media/texp7.006dfbe3.png";